webpackJsonp([1],Array(58).concat([
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__(95);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b105dc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__(120);
function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b105dc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b105dc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(66)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(70);
var defined = __webpack_require__(71);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(84);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(63);
var core = __webpack_require__(62);
var ctx = __webpack_require__(73);
var hide = __webpack_require__(75);
var has = __webpack_require__(68);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(74);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(76);
var createDesc = __webpack_require__(81);
module.exports = __webpack_require__(65) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(77);
var IE8_DOM_DEFINE = __webpack_require__(78);
var toPrimitive = __webpack_require__(80);
var dP = Object.defineProperty;

exports.f = __webpack_require__(65) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(65) && !__webpack_require__(66)(function () {
  return Object.defineProperty(__webpack_require__(79)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
var document = __webpack_require__(63).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(64);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(83);
var enumBugKeys = __webpack_require__(92);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(68);
var toIObject = __webpack_require__(67);
var arrayIndexOf = __webpack_require__(85)(false);
var IE_PROTO = __webpack_require__(88)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(86);
var toAbsoluteIndex = __webpack_require__(87);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(69);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(69);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(89)('keys');
var uid = __webpack_require__(91);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(62);
var global = __webpack_require__(63);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(90) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 93 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Team",
  data: function data() {
    return {
      displayName: "",
      rotate: -90,
      max: 30
    };
  },

  components: {
    ModalNotificationMessage: function ModalNotificationMessage() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 116));
    }
  },
  computed: {
    notificationGranted: function notificationGranted() {
      if (Notification.permission == "granted") {
        return true;
      } else {
        return false;
      }
    },
    team: function team() {
      return this.$store.getters.team;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    teamSorted: function teamSorted() {
      //console.log(this.team)
      var array = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.team).sort(function (a, b) {
        return a.experience < b.experience ? 1 : b.experience < a.experience ? -1 : 0;
      });
      return array;
    }
  },
  methods: {
    logout: function logout() {
      /*this.$store.dispatch("logout");
      this.$store.commit("SET_USER", null);
      this.$router.push("/signin")*/
      //this.$store.dispatch("fetchNewMember");
    },
    openModalNotificationMessage: function openModalNotificationMessage(teamMember, index) {
      if (teamMember.endpoint) {
        this.$store.commit("SET_TEAM_MEMBER", teamMember);
        this.$store.commit("SET_MODAL_NOTIFICATION_MESSAGE", true);
      }
    }
    /*share() {
      this.$store.commit("SET_SNACKBAR", "Link copied to clipboard");
    }*/

  }
});

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(111);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(56)("7220aac3", content, true, {});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(55)(true);
// imports


// module
exports.push([module.i, ".avatar[data-v-6b105dc8]{height:40px;width:40px;background-position:50%;background-size:40px;position:relative;margin-right:10px}.rank[data-v-6b105dc8]{width:34px;margin-left:6px;font-size:10px}.message[data-v-6b105dc8],.rank[data-v-6b105dc8]{background-color:#fff;border-radius:10px;height:15px;color:#23a6d5;text-align:center;margin-top:-15px;position:absolute}.message[data-v-6b105dc8]{width:15px;margin-left:26px}.add[data-v-6b105dc8]{cursor:pointer;background-color:#fff;border-radius:25px;text-align:center;padding-top:9px;width:60px;color:#23a6d5;height:40px}", "", {"version":3,"sources":["C:/Users/felix/Google Drive/Travail/Mes projets/antibide/src/components/Team.vue"],"names":[],"mappings":"AACA,yBACE,YAAa,AACb,WAAY,AACZ,wBAA4B,AAC5B,qBAAsB,AACtB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,uBAIE,WAAY,AACZ,gBAAiB,AAGjB,cAAgB,CAGjB,AACD,iDAXE,sBAAwB,AACxB,mBAAoB,AACpB,YAAa,AAGb,cAAe,AACf,kBAAmB,AAEnB,iBAAkB,AAClB,iBAAmB,CAYpB,AAVD,0BAIE,WAAY,AACZ,gBAAkB,CAKnB,AACD,sBACE,eAAgB,AAChB,sBAAwB,AACxB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AACZ,cAAe,AACf,WAAa,CACd","file":"Team.vue","sourcesContent":["\n.avatar[data-v-6b105dc8] {\n  height: 40px;\n  width: 40px;\n  background-position: center;\n  background-size: 40px;\n  position: relative;\n  margin-right: 10px;\n}\n.rank[data-v-6b105dc8] {\n  background-color: white;\n  border-radius: 10px;\n  height: 15px;\n  width: 34px;\n  margin-left: 6px;\n  color: #23a6d5;\n  text-align: center;\n  font-size: 10px;\n  margin-top: -15px;\n  position: absolute;\n}\n.message[data-v-6b105dc8] {\n  background-color: white;\n  border-radius: 10px;\n  height: 15px;\n  width: 15px;\n  margin-left: 26px;\n  color: #23a6d5;\n  text-align: center;\n  margin-top: -15px;\n  position: absolute;\n}\n.add[data-v-6b105dc8] {\n  cursor: pointer;\n  background-color: white;\n  border-radius: 25px;\n  text-align: center;\n  padding-top: 9px;\n  width: 60px;\n  color: #23a6d5;\n  height: 40px;\n}\n*[data-v-6b105dc8] {\n  /*border: solid 1px red;*/\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(113), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
module.exports = __webpack_require__(62).Object.values;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(72);
var $values = __webpack_require__(115)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(82);
var toIObject = __webpack_require__(67);
var isEnum = __webpack_require__(93).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{on:{"click":function($event){_vm.logout()}}},[_c('div',{staticStyle:{"position":"relative","margin-right":"10px"}},[_c('v-tooltip',{attrs:{"bottom":"","color":"secondary"}},[_c('h2',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("Team")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#23a6d5"}},[_vm._v("The experience is reset every day")])])],1)]),_vm._v(" "),_c('v-layout',{attrs:{"mt-2":""}},[(!_vm.team)?_c('v-progress-circular',{staticStyle:{"margin-right":"10px"},attrs:{"size":40,"width":4,"indeterminate":"","color":"secondary"}}):[_vm._l((_vm.teamSorted),function(teamMember,index){return _c('div',{key:index,staticStyle:{"display":"inline-block"},on:{"click":function($event){_vm.openModalNotificationMessage(teamMember, index)}}},[_c('div',{staticStyle:{"position":"absolute","margin-top":"0px"}},[_c('div',{staticClass:"avatar",style:({ 'background-image':'url('+ teamMember.photoURL +')'})})]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","margin-right":"10px"}},[(!teamMember.endpoint)?_c('v-tooltip',{attrs:{"bottom":"","color":"secondary"}},[_c('v-progress-circular',{attrs:{"slot":"activator","color":"secondary","size":"40","rotate":_vm.rotate,"value":teamMember.experience/3},slot:"activator"}),_vm._v(" "),_c('span',{staticStyle:{"color":"#23a6d5"}},[_vm._v(_vm._s(teamMember.displayName)+": "+_vm._s(teamMember.experience)+"xp")])],1):_c('v-progress-circular',{attrs:{"color":"secondary","size":"40","rotate":_vm.rotate,"value":teamMember.experience/3}})],1),_vm._v(" "),(teamMember.endpoint)?_c('div',{staticClass:"message"},[_c('v-icon',{staticStyle:{"font-size":"10px","margin-top":"-8px"},attrs:{"color":"primary"}},[_vm._v("message")])],1):_vm._e(),_vm._v(" "),(index==0 && teamMember.experience>0)?_c('div',{staticClass:"rank"},[_vm._v("1st"),(teamMember.endpoint)?_c('v-icon',{staticStyle:{"font-size":"10px","margin-left":"3px","margin-right":"-2px"},attrs:{"color":"primary"}},[_vm._v("message")]):_vm._e()],1):_vm._e(),_vm._v(" "),(index==1 && teamMember.experience>0)?_c('div',{staticClass:"rank"},[_vm._v("2nd"),(teamMember.endpoint)?_c('v-icon',{staticStyle:{"font-size":"10px","margin-left":"3px","margin-right":"-2px"},attrs:{"color":"primary"}},[_vm._v("message")]):_vm._e()],1):_vm._e(),_vm._v(" "),(index==2 && teamMember.experience>0)?_c('div',{staticClass:"rank"},[_vm._v("3rd"),(teamMember.endpoint)?_c('v-icon',{staticStyle:{"font-size":"10px","margin-left":"3px","margin-right":"-2px"},attrs:{"color":"primary"}},[_vm._v("message")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.notificationGranted)?_c('ModalNotificationMessage'):_vm._e()],1)}),_vm._v(" "),(_vm.user)?_c('social-sharing',{staticClass:"hidden-sm-and-up",attrs:{"url":'https://antibideforever.firebaseapp.com/signin/'+_vm.user.team},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{attrs:{"network":"whatsapp"}},[_c('div',{staticClass:"elevation-1",staticStyle:{"cursor":"pointer","background-color":"white","border-radius":"25px","text-align":"center","padding-top":"9px","width":"60px","color":"#23a6d5","height":"40px"}},[_vm._v("+"),_c('span',{staticStyle:{"margin-bottom":"-5px"}},[_vm._v("ADD")])])])},staticRenderFns:[]}}):_vm._e()]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/1.9c67bb2b3cc9d402f144.js